import React from "react";
import { useHistory } from "react-router-dom";
import { Text } from "components/Text";
import Colors from 'constants/Colors';
import { LayoutCircle, Content, Section, Spacer } from "./styles";

const Subtitle = ({ stage, idProduct, idOperation, cantGoBack, statusOperation, activeColor = Colors.SECONDARY }) => {
  const history = useHistory();

  const tabList = {
    BasicInfo: 1,
    ProductPlan: 2,
    PolicyIssue: 3
  }

  const handleClick = function(tabId){
    const stageList={
      STAGE_QUESTION: 1,
      STAGE_PLANS: 2,
      STAGE_PAYMENT: 3,
      STAGE_DOCS: 3
    }
    const statusList={
      STATUS_WORKING: 1,
      STATUS_LOST: 2,
      STATUS_CREATED: 7,
      STATUS_ISSUED: 5,
      STATUS_ISSUE_PENDING: 6
    }
    switch (tabId){
      
      case tabList.BasicInfo:
        return (stage === stageList.STAGE_QUESTION 
          || cantGoBack 
          || statusOperation == statusList.STATUS_ISSUED 
          || statusOperation == statusList.STATUS_LOST
          || statusOperation == statusList.STATUS_ISSUE_PENDING
          ? null
          : history.push(`/quotes/info/${idProduct}/${idOperation}`, { idOperation }));        

      case tabList.ProductPlan:
        return (stage === stageList.STAGE_PLANS 
          || statusOperation == statusList.STATUS_WORKING
          || statusOperation == statusList.STATUS_CREATED 
          || statusOperation == null
          || cantGoBack  
          || statusOperation == statusList.STATUS_ISSUED 
          || statusOperation == statusList.STATUS_LOST
          || statusOperation == statusList.STATUS_ISSUE_PENDING
          ? null
          : history.push(`/quotes/plans/${idProduct}/${idOperation}`, { idOperation }));

      case tabList.PolicyIssue:
        return (stage === stageList.STAGE_PAYMENT
          || statusOperation == statusList.STATUS_WORKING 
          || cantGoBack 
          || statusOperation == statusList.STATUS_WORKING
          || statusOperation == statusList.STATUS_ISSUED 
          || statusOperation == statusList.STATUS_LOST          
          || statusOperation == statusList.STATUS_ISSUE_PENDING
          || statusOperation == null
          ? null
          : history.push(`/quotes/payments/${idProduct}/${idOperation}`, { idOperation }));
      
      default:
        return;
    }
  }

  const activeColorText = (activeStage) =>{
    if(activeStage !== stage) return {color:"#888888"};
  }

  return (
    <Content>
      <Section>
        <LayoutCircle
          onClick={ () => handleClick(tabList.BasicInfo) }
          isActive={stage === 1}
          activeColor={activeColor}
        >
          1
        </LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true} style={activeColorText(1)}>INFORMAÇÕES BÁSICAS</Text>
      </Section>
      <Spacer className="d-sm-none"></Spacer>
      
      <Section>
        <LayoutCircle
          onClick={ () => handleClick(tabList.ProductPlan) }
          isActive={ stage === 2}
          activeColor={activeColor}
        >
          2
        </LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true} style={activeColorText(2)}>SELEÇÃO DE PLANOS</Text>
      </Section>
      <Spacer className="d-sm-none"></Spacer>

      <Section>
        <LayoutCircle
          onClick={ () => handleClick(tabList.PolicyIssue) }
          isActive={stage === 3}
          activeColor={activeColor}
        >
          3
        </LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true} style={activeColorText(3)}>EMISSÃO DE DOCUMENTOS</Text>
      </Section>
    </Content>
  );
};

export default Subtitle;
